import { Storage } from '@ionic/storage';
import { UserState } from '../../../../hooks/authUtils';
import { EquipmentGenericItemType } from '../../../../graphql/EquipmentGenericItemType';
import useBaseCacheAndList from '../../../../hooks/baseCacheAndList';
import GET_EQUIPMENT_STATUS_LIST from '../graphql/GetEquipmentStatus';
import equipmentKeys from './equipmentKeys';
import { DomainParams } from '../../../../hooks/graphQLClientUtil';


const useEquipmentStatus = (region: number, userState: UserState, storage: Storage) => {
  const equipmentBranches: EquipmentGenericItemType[] = useBaseCacheAndList(
    region,
    userState,
    storage,
    GET_EQUIPMENT_STATUS_LIST,
    equipmentKeys.equipmentStatusList(),
    'statusList',
    DomainParams.Equipments);
  return equipmentBranches;
};

export default useEquipmentStatus;